import clsx from 'clsx';
import React, { useEffect } from 'react';
import Styles from './BancoDoAuto25Stack.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import { useLayout } from '@/utils/useLayout';

function BancoDoAuto25Stack({ children, ...props }) {
  const { width, mobile } = useLayout();

  useEffect(() => {
    if (mobile) return;

    const textSize = 453;
    const gap = 86;
    const containerPadLeft = 45;
    const minPadRight = 16;
    const space = width - minPadRight - (textSize + gap + containerPadLeft);

    const elem = document.querySelector('.c2c-stack .c2c-video-container');
    if (!elem) return;

    elem.style.maxWidth = `${Math.min(space, 726)}px`;
  }, [width, mobile]);

  return (
    <>
      <ContainerHome24>
        <div {...props} className={clsx('c2c-stack', props.className)}>
          {children}
        </div>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </>
  );
}

export default BancoDoAuto25Stack;
